import { ReactElement } from 'react';

/** This is a React Button type extended to suport prop based conditional style. */
export type TButton = {
  type: 'button' | 'submit' | 'reset';
  /** A string or react icon to be shown inside the button.
   * @example
   * <Button>
   *   <MdFileDownload fill="#000000" />
   * </Button
   */
  children: string | ReactElement;
  justify?: 'center' | 'left' | 'right';
  block?: boolean;
  small?: boolean;
  disabled?: boolean;
  /** Customization for store page button. */
  store?: 'download' | 'update' | 'delete';
} & React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

/**
 * Object representing a dashboard permission item.
 * Contains Dashboard data and a permition identification.
 */
export type TDashboardPermission = {
  codDashboard: number;
  titulo: string;
  liberado: boolean;
  modulo: string;
};

/**
 * Object representing a dashboard publication item.
 * Contains Dashboard data and a publication status.
 */
export type TDashboardPublication = {
  codDashboard: number;
  idExterno: string;
  titulo: string;
  descricao: string;
  modulo: string;
  atualizadoEm: string;
  status: number;
};

/**
 * Object representing a dashboard store item.
 * Contains Dashboard data and a store status.
 */
export type TDashboardStore = {
  modulo: string;
  id: string;
  titulo: string;
  descricao: string;
  hash: string;
  /**
   * 1 - Not downloaded.
   * 2 - Downloaded.
   * 3 - Pending update.
   */
  status: number;
  /**
   * Se a versão publicada já tem conversão para o viewer novo. Quando falso, o
   * dashboard abre, mas cai no viewer antigo até alguém reconverter.
   */
  convertido?: boolean;
  /**
   * Falso no dashboard privado, publicado só para as unidades de uma instalação.
   * A API manda nulo, e não ausente, quando o OnPremises não conhece o campo.
   */
  isPublic?: boolean | null;
  /** Unidade de quem publicou o privado; nula no público. */
  unidade?: string | null;
  atualizadoEm: Date;
  imagens?: {
    grid?: string;
    light?: [string];
    dark?: [string];
  };
  loading?: boolean;
};

export type TRoute = {
  /** Relative URL path */
  path: string;
  /** Is a authentication required route */
  auth?: boolean;
  /** Exact route only, excluding derived routes */
  exact?: boolean;
  /** If it should be redirected, to which route it should be */
  redirect: string;
  /** Component to be rendered */
  component: any;
};

export type TStoreimage = {
  grid?: string;
  light?: Array<string>;
  dark?: Array<string>;
};

/** Contains a users data */
export type TUserData = {
  usuario: string;
  email: string;
  nome: string | null;
  administradorPainel: number;
};

export enum TypePermission {
  usuario = 0,
  administradorPainel = 1,
  editor = 2,
  revisor = 3,
}
